import React from 'react';
import cls from 'classnames';
import _isArray from 'lodash/isArray';
import ChevronDownIcon from '@ott/icon-chevron-down';
import styles from './DropdownTrigger.scss';

interface Props {
  value: any;
  label: string;
  placeholder: string;
  isOpen: boolean;
  shouldKeepTriggerOpened: boolean;
  isDark: boolean;
  caption: string;
}

const DropdownTrigger: React.FC<Props> = (props) => {
  const {
    value,
    label,
    placeholder,
    isOpen,
    shouldKeepTriggerOpened,
    isDark = false,
    caption,
  } = props;

  return (
    <div className={cls(styles.triggerInner, isDark && styles.isDark)}>
      <div className={styles.textContainer}>
        <div className={styles.title}>{label}</div>
        <div className={styles.text}>{value?.name ? `${caption} ${value.name}` : placeholder}</div>
      </div>
      <ChevronDownIcon
        className={cls(styles.arrow, {
          [styles.isOpen]: isOpen || shouldKeepTriggerOpened,
          [styles.isDark]: isDark,
        })}
      />
    </div>
  );
};

export default DropdownTrigger;
